import { render, staticRenderFns } from "./FormPgt.vue?vue&type=template&id=fa2e2726&scoped=true"
import script from "./FormPgt.vue?vue&type=script&lang=ts"
export * from "./FormPgt.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=fa2e2726&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2e2726",
  null
  
)

export default component.exports